import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DocumentSchema, SchemaField } from 'src/app/modules/core/store/models/document.model';
import { Workflow } from 'src/app/modules/core/store/models/workflow.model';
import { LinkFilterGroup } from '../../../store/models/link-filters.model';
import { Dataset } from '../../../store/models/dataset.model';

@Component({
    selector: 'topo-document-link-filter-dialog',
    templateUrl: './document-filter-dialog.component.html',
    styleUrls: ['./document-filter-dialog.component.scss'],
    standalone: false
})
export class DocumentLinkFilterDialogComponent {
  @Input() isActive: boolean;
  @Input() filterGroup: LinkFilterGroup;
  @Input() datasets: Dataset[];
  @Input() lookupTargetSchemaFields: SchemaField[];
  @Output() cancel = new EventEmitter<void>();
  @Output() filterChanged = new EventEmitter<LinkFilterGroup>();

  constructor() {}

  cancelClick(): void {
    this.cancel.emit();
  }

  saveClick(): void {
    this.filterChanged.emit(this.filterGroup);
  }
}
